module.exports = __webpack_public_path__ + "img/people_img_2_1.4943356a.png";